import { render, staticRenderFns } from "./ViewAllRegistrations.vue?vue&type=template&id=567b3b46&scoped=true&"
import script from "./ViewAllRegistrations.vue?vue&type=script&lang=js&"
export * from "./ViewAllRegistrations.vue?vue&type=script&lang=js&"
import style0 from "./ViewAllRegistrations.vue?vue&type=style&index=0&id=567b3b46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567b3b46",
  null
  
)

export default component.exports